<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <img class="brand-logo" src="assets/images/logo.png">
            <button type="button" class="close-button" (click)="dialogRef.close()">&times;</button>
        </div>
        <div class="col-md-12 my-3">
            <img class="profile-avatar" [src]="'assets/images/avatars/avatar' + data?.avatar + '.png'" />
            <span class="clr-pri-text-f h2 ver-mid">{{"gen_edit_profile" | translate}}</span>
        </div>
    </div>
</div>

<!-- Options -->
<div class="container-fluid">
    <div class="row mb-3" *ngFor="let option of options" (click)="doAction(option)">
        <div class="col-md-6 options-container h3 py-3">
            <i [ngClass]="option.icon"></i>
            <img [src]="option.image" *ngIf="option.image" />
            {{option.name | translate}}
        </div>
    </div>
</div>